import script from "./PaymentSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaymentSection.vue?vue&type=script&setup=true&lang=ts"

import "./PaymentSection.vue?vue&type=style&index=0&id=7b88df2c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b88df2c"]])

export default __exports__